var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card container"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.pages.title.rendered))]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.pages.content.rendered)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69cad9ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages.vue
// module id = null
// module chunks = 